'use strict';

angular.module('directives.empStaging')

	.controller('empStagingMatchingNewStatusController', ['$scope', '$modal', 'employeeSyncService', function ($scope, $modal, employeeSyncService) {


		// Show Confirm Matching Modal
		$scope.showConfirmMatchingModal = function ($event) {
			$event.stopPropagation();
			if ($scope.readOnly) return false;

			var modalScope = $scope.$new(true);

			modalScope.model = $scope.model;

			modalScope.modalCtxt = {};
			modalScope.modalCtxt.askForEffectiveDate = true;
			modalScope.modalCtxt.effectiveDate = moment().format('YYYY-MM-DD');
			modalScope.ctrlCtxt = $scope.ctrlCtxt;

			// Get Ignored Matchings When Confirm Matching
			employeeSyncService
				.getIgnoredMatchingsWhenConfirmMatching($scope.model)
				.then(function (ignoredMatchings) {
					modalScope.ignoredMatchings = ignoredMatchings;
				});

			var confirmMatchingModal = $modal({
				scope: modalScope,
        template: require('./empStagingDirective-matching-DetectEmployeeNewStatus-confirmModal.tpl.html'),
				placement: 'center'
			});

			modalScope.hideModal = function () {
				return confirmMatchingModal.$promise.then(confirmMatchingModal.hide);
			}

			modalScope.okModal = function () {
				modalScope.hideModal();
			}

			modalScope.refreshPage = function () {
				window.location.reload();
				// $state.reload();  Bug with UI-Router 0.2.13, fixed in 0.2.15 (produces more bugs elsewhere)
			};

			// Go To Ask For Effective Date
			modalScope.goToAskForEffectiveDate = function () {
				modalScope.modalCtxt.askForEffectiveDate = true;
			};

			// Show Ask For Effective Date?
			modalScope.showAskForEffectiveDate = function () {
				return modalScope.modalCtxt.askForEffectiveDate;
			};

			// Is Confirm Matching Action Disabled?
			modalScope.isConfirmMatchingActionDisabled = function () {
				if ($scope.ctrlCtxt.isLoading) return true;
				if (_.isUndefined(modalScope.modalCtxt.effectiveDate)) return true;

				return !modalScope.modalCtxt.effectiveDate;
			};

			// Confirm Matching
			modalScope.confirmMatching = function () {

				$scope.ctrlCtxt.isLoading = true;
				employeeSyncService
					.getLatestBatch()
					.then(function (latestBatch) {
						if (!_.isUndefined($scope.boxContext) && !_.isUndefined($scope.boxContext.latestClosedBatch)) {
							modalScope.isLatestBatchDifferent = latestBatch.PubEmp_BatchID !== $scope.boxContext.latestClosedBatch.PubEmp_BatchID;
						}

						if (!modalScope.isLatestBatchDifferent) {

							return employeeSyncService
								.confirmMatchingWithEffectiveDate($scope.model, modalScope.modalCtxt.effectiveDate)
								.then(function () {
									return $scope
										.refreshMatchingsAndExceptions()
										.then(function () {
											modalScope.hideModal();
										});
								});
						}
					})
					.finally(function () {
						$scope.ctrlCtxt.isLoading = false;
					});

			};
		};

	}]);
